import { render, staticRenderFns } from "./PackageSettigns.vue?vue&type=template&id=fcaedc9e&scoped=true"
import script from "./PackageSettigns.vue?vue&type=script&lang=js"
export * from "./PackageSettigns.vue?vue&type=script&lang=js"
import style0 from "./PackageSettigns.vue?vue&type=style&index=0&id=fcaedc9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcaedc9e",
  null
  
)

export default component.exports